module.exports = __webpack_public_path__ + "static/media/02-11-1.1ffe1f50.png";